import RouteCardLateTaskPrompt from './RouteCardLateTaskPrompt';

export default RouteCardLateTaskPrompt;
